import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@gasbuddy/react-components';
import BannerMessage from '../../banner-message';
import GridColumns from '../../grid-columns';
import FuelPriceProps from '../../../utils/prop-types/fuel-price';
import FuelTypeProps from '../../../utils/prop-types/fuel-type';
import PriceItem from './price-item';
import styles from './styles.css';

const { sortByFuelTypes } = require('../../../../lib/bputils').default;

export default function FuelPriceContent({
  prices,
  currentStationPrices,
  fuelTypes: fuelTypesProps,
  hasCashPrices,
  notifyToEditPrices,
  onPriceBlur: onPriceBlurProps,
  isEditing: isEditingProps,
  country,
  showPricesBeingUpdated,
}) {
  const [isEditing, setIsEditing] = React.useState(isEditingProps);
  const [fuelTypes, setFuelTypes] = React.useState(sortByFuelTypes(fuelTypesProps));

  React.useEffect(() => {
    setFuelTypes(sortByFuelTypes(fuelTypesProps));
  }, [fuelTypesProps]);

  React.useEffect(() => {
    setIsEditing(isEditingProps);
  }, [isEditingProps]);

  const onPriceBlur = (price) => {
    onPriceBlurProps(price);
  };

  return (
    <>
      {showPricesBeingUpdated ? <BannerMessage upperCase message="PRICES ARE BEING VALIDATED AND THEN POSTED TO THE GASBUDDY APP" /> : null}
      <div className={styles.pricesContainer}>
        {(!fuelTypes?.length) ? <BannerMessage message="PLEASE UPDATE YOUR STATION PRICES" /> : null}
        {fuelTypes?.length
          ? (
            <div className={`${styles.pricesRowCredit} ${hasCashPrices ? styles.pricesRowHasCash : ''}`}>
              <div className={`${styles.creditBox} ${styles.creditCashBoxLabels} ${hasCashPrices ? styles.pricesRowHasCash : ''}`}>CREDIT</div>
              <GridColumns
                centered
                contents={
                    fuelTypes.map((fuelType) => {
                      const price = prices.find(p => p.fuel_product === fuelType.id);
                      const currentStationPrice = currentStationPrices.find(p => p.fuel_product === fuelType.id);

                      return {
                        title: fuelType.display_name,
                        body: (
                          <PriceItem
                            price={price?.credit || { price: 0 }}
                            currentStationPrice={currentStationPrice?.credit || { price: 0 }}
                            onUpdatePriceClick={notifyToEditPrices}
                            isEditing={isEditing}
                            country={country}
                            onPriceBlur={onPriceBlur}
                            fuelProduct={fuelType.id}
                            priceType="credit"
                          />),
                        key: `${fuelType.id}_credit`,
                      };
                    })
                  }
              />
            </div>
          ) : null
        }
        {!!fuelTypes?.length && hasCashPrices
          ? (
            <div className={`${styles.pricesRowCash} ${hasCashPrices ? styles.pricesRowHasCash : ''}`}>
              <Divider className={styles.pricesRowDivider} />
              <div className={`${styles.cashBox} ${styles.creditCashBoxLabels} ${hasCashPrices ? styles.pricesRowHasCash : ''}`}>CASH</div>
              <GridColumns
                centered
                contents={
                    fuelTypes.map((fuelType) => {
                      const price = prices.find(p => p.fuel_product === fuelType.id);
                      const currentStationPrice = currentStationPrices.find(p => p.fuel_product === fuelType.id);

                      return {
                        body: (
                          <PriceItem
                            price={price?.cash || { price: 0 }}
                            currentStationPrice={currentStationPrice?.cash || { price: 0 }}
                            onUpdatePriceClick={notifyToEditPrices}
                            isEditing={isEditing}
                            country={country}
                            onPriceBlur={onPriceBlur}
                            fuelProduct={fuelType.id}
                            priceType="cash"
                          />),
                        key: `${fuelType.id}_cash`,
                      };
                    })
                  }
              />
            </div>
          ) : null
        }
      </div>
    </>
  );
}

FuelPriceContent.propTypes = {
  prices: PropTypes.arrayOf(FuelPriceProps),
  currentStationPrices: PropTypes.arrayOf(FuelPriceProps),
  fuelTypes: PropTypes.arrayOf(FuelTypeProps),
  hasCashPrices: PropTypes.bool,
  notifyToEditPrices: PropTypes.func,
  onPriceBlur: PropTypes.func,
  isEditing: PropTypes.bool,
  country: PropTypes.string.isRequired,
  showPricesBeingUpdated: PropTypes.bool,
};

FuelPriceContent.defaultProps = {
  prices: [],
  currentStationPrices: [],
  fuelTypes: undefined,
  hasCashPrices: false,
  notifyToEditPrices: () => {},
  onPriceBlur: () => {},
  isEditing: false,
  showPricesBeingUpdated: false,
};
